module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-PW-Australia-Landing-page.06f3304a.jpg";